/**
 * api 接口
 * @author: kinds
 * @create: 2017-11-20 14:35
 */
import Vue from 'vue';
import axios from "axios";
import router from "../router";
import {
    message as Message
} from 'ant-design-vue';
// const _domain = process.env.VUE_APP_API_URL;
const _domain = baseConfig.vue_base_url;

// 创建axios实例
const axiosInstance = axios.create({
    baseURL: _domain, //url
    headers: {
        //将被发送的自定义请求头
        "Content-Type": "application/x-www-form-urlencoded"
    },
    withCredentials: true, //表示跨域请求时是否需要使用凭证
    timeout: 50000 //请求超时的毫秒数
});

// 添加请求拦截器
axiosInstance.interceptors.request.use(
    function (config) {
        // 在发送请求之前做些什么
        let _token = localStorage.getItem("_token");
        config.headers['token'] = _token ? _token : "";
        return config;
    },
    function (error) {
        // 对请求错误做些什么
        return Promise.reject(error);
    }
);

// 添加响应拦截器
axiosInstance.interceptors.response.use(
    function (response) {
        if (/admin\/user\/login/.test(response.request.responseURL)) {
            return response.data;
        }
        // 对响应数据做点什么
        if (response.data.code == 0 || response.data.code == 1 || response.data.code == 200) {
            return response.data;
        }
        // 登录失效
        else if (response.data.code == 403) {
            localStorage.removeItem("_token");
            Message.error(response.data.msg);
            router.push({
                path: "/login"
            });
        } else {
            Message.error(response.data.msg);
            return Promise.reject(new Error(response.data.msg));
        }
    },
    function (error) {
        // 对响应错误做点什么
        if(error.response.data.code){
            Message.error(error.response.data.msg);
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;
export const domain = _domain;